import { WhyUto } from '../../assets/index';
const data = [
    {
        id: 1,
        title: 'Custom Metaverse',
        para: 'The Metaverse Builder supports importing your own images, videos, hyperlinks, 3-Models and will soon support live audio and video streams as well. Users have the ability to build their own verse and deploy their own digital assets.',
        img:WhyUto.im1
    },
    {
        id: 2,
        title: 'Universal Token',
        para: 'Utopia42 will soon be integrated with Utopia42 token (U42G) and a governance protocol. Decisions regarding the direction of development and growth of Utopia42 are made by members of the <a href="https://vote.utopia42.club">Utopia42 DAO governance</a>.',
        img:WhyUto.im2
    },
    {
        id: 3,
        title: 'Decentralized Protocol',
        para: 'Utopia42 currently runs on polygon main net, so saving your world data is inexpensive and secured forever in the ethereum/polygon blockchains.  We are working to enhance cross chain compatibility and decentralized identity with our friends at <a href="https://www.muon.net/" target="_blank">Muon Network</a> and <a href="https://www.brightid.org/" target="_blank">BrightID</a>.',
        img:WhyUto.im3
    }
]
export default data;